import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';

const RESUME_QUEUE_JOB = gql`
  mutation ResumeQueueJob($id: String!) {
    resumeQueueJob(id: $id)
  }
`;

export const useResumeQueueJob = () => {
  const [resumeQueueJob] = useMutation(RESUME_QUEUE_JOB);

  const resumeJob = async (id: string) => {
    try {
      await resumeQueueJob({variables: {id}});
      return true;
    } catch (error) {
      console.error('Failed to resume job:', error);
      return false;
    }
  };

  return resumeJob;
};
